import {
  Box,
  CircularProgress,
  type CircularProgressProps,
} from '@mui/material';

type Props = CircularProgressProps & {
  fullScreen?: boolean;
  centered?: boolean;
  'aria-label'?: string;
};

export function Spinner({
  centered,
  fullScreen,
  sx,
  'aria-label': ariaLabel = 'loading',
  ...progressProps
}: Props) {
  const spinner = (
    <CircularProgress {...progressProps} aria-label={ariaLabel} />
  );

  if (centered || fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: fullScreen ? '100dvh' : undefined,
          ...sx,
        }}
      >
        {spinner}
      </Box>
    );
  }

  return spinner;
}
